<div class="new-options pt-5 pb-1">
    <label class="rating-select2__option rating-select2__option new-options--has-feedback position-relative font-16 lh-30 mg-b15">
        <span class="rating-select2__radiotext">
            <span class="rating-select2__title">Feedback from faculty</span>
        </span>
        <div class="has-feedback">
            <span class="has-feedback--icon"><span>?</span></span>
            <div class="has-feedback--dropdown has-feedback--dropdown__top">This feedback has been provided after being reviewed by our faculty.</div>
        </div>
    </label>
</div>

<ul [attr.id]="'feedbackaccordion'+taFeedback.elementId" class="courseAccordion courseAccordion--light">
  <li *ngFor="let item of taFeedback.rowsFeedback;let i=index" class="card mb-1">
    <div class="card-header border-0" id="feedbackone" [attr.title]="i">
      <h5 class="mb-0">
        <button class="btn btn-link" data-bs-toggle="collapse" [attr.data-bs-target]="'#feedback'+taFeedback.elementId+i"
          [attr.aria-expanded]="false" [attr.aria-controls]="'#feedback'+taFeedback.elementId+i">
          <span *ngIf="item.total" style="position: static" class="float-right answer-point">Points: {{item?.points}} out
            of
            {{item?.total}}</span>
          <span class="lh-24"><strong>{{item?.title}}</strong></span>
          <i class="icon-angle-bottom"></i>
        </button>
      </h5>
    </div>
    <div [attr.id]="'feedback'+taFeedback?.elementId+i" class="collapse"
      [attr.aria-labelledby]="'feedbackheadingOne'+taFeedback?.elementId+i"
      [attr.data-bs-parent]="'#feedbackaccordion'+taFeedback?.elementId">
      <div class="card-body">

        <div class="rating-blocks question__rank mb-5">

          <div *ngFor="let block of item.cellInfo;let j=index" class="rating-block text-center"
            [class.rating-block--active]="getSelectedCell(block.id)" 
            [ngClass]="{
              'rating--exemplary': block.title == 'Exemplary' && getSelectedCell(block.id),
              'rating--good': block.title == 'Good' && getSelectedCell(block.id),
              'rating--acceptable': block.title == 'Acceptable' && getSelectedCell(block.id),
              'rating--unacceptable': block.title == 'Unacceptable' && getSelectedCell(block.id)
            }">
            <!-- <span class="rating-block-icon pb-2">
              <i class="rating-block-icon__icon icon-favorite-star"></i>
              <span class="rating-block-icon__count">1</span>
            </span> -->
            <p class="rating-block__title">{{block?.title}}</p>
            <p class="rating-block__subtitle pb-2">{{block?.description}}
            </p>
          </div>
        </div>

        <div class="overall-feedback" *ngIf="item?.feedback">
          <!-- <h3 class="overall-feedback__title mb-2">You picked the right answer</h3> -->
          <p class="overall-feedback__desc">{{item?.feedback}}</p>
        </div>

      </div>
    </div>
  </li>
</ul>
